<template>
    <div class="private-detail">
        <div class="jc-page-header">
            <el-page-header show-back-icon :title="$t('privateNetwork.privateNetwork')" @back="goBack" class="relative">
                <template slot="content">
                    <span class="long-name" :title="detail.name">
                        {{ detail.name }}
                    </span>
                    <div class="jc-list__header--right jc-box-action">
                        <a target="_blank" :href="Config.CPS_HELP_URL">{{ $t('privateNetwork.privateHelpDoc') }}</a>
                        <drop-down-operation :operations="operates" @clickSelectItem="selectOps"
                            :buttonTitle="$t('privateNetwork.operate')">
                        </drop-down-operation>
                    </div>
                </template>
            </el-page-header>
        </div>
        <div class="jc-page-content">
            <el-tabs type="border-card" v-model="tabName">
                <el-tab-pane name="source" :label="$t('privateNetwork.sourceInfo')">
                    <div class="jc-section">
                        <div class="jc-section-header">
                            <h3 class="jc-section-title">{{ $t('privateNetwork.baseInfo') }}</h3>
                        </div>
                        <div class="jc-section-content">
                            <el-form class="base-info-form">
                                <el-row :gutter="20">
                                    <el-col :span="8">
                                        <el-form-item :label="$t('privateNetwork.id') + ': '">
                                            <p>
                                                <span>{{ detail.vpcId | maybeEmpty }}</span>
                                                <copy-value :copyVal="`${detail.vpcId}`"></copy-value>
                                                <!-- <el-tooltip :content="$t('privateNetwork.copySuccess')" effect="dark"
                                                    placement="bottom" :disabled="!copyHover" class="tooltip-item">
                                                    <span @mouseout="copyHover = false">
                                                        <el-button type="text" icon="el-icon-document-copy"
                                                            v-clipboard:copy="detail.vpcId" v-clipboard:success="onCopy"
                                                            v-clipboard:error="onError">
                                                        </el-button>
                                                    </span>
                                                </el-tooltip> -->
                                            </p>
                                        </el-form-item>
                                    </el-col>
                                    <el-col :span="8">
                                        <el-form-item :label="$t('privateNetwork.name') + ': '">
                                            <span :title="detail.name">{{ detail.name | maybeEmpty }}</span>
                                            <el-popover ref="editValue" trigger="click" :visible-arrow="false" :offset="0"
                                                placement="left-start" :width="300" v-if="showEditName"
                                                :value="showEditName">
                                                <edit-value :inputVal="detail.name" v-if="showEditName"
                                                    :inputValRule="rules.name" @sureEdit="handleEditName"
                                                    :popTitle="$t('privateNetwork.editName')"
                                                    :showEditDes.sync="showEditName">
                                                </edit-value>
                                            </el-popover>
                                            <el-button type="text" icon="jc-icon-edit" @click="showEditName = true"
                                                v-popover:editValue>
                                            </el-button>
                                            <div class="jc-colude-mask" v-if="showEditName"></div>
                                        </el-form-item>
                                    </el-col>
                                    <el-col :span="8">
                                        <el-form-item :label="$t('privateNetwork.description') + ': '" class="edit-jc-form">
                                            <span :title="detail.description" class="instance-name">
                                                {{ detail.description | maybeEmpty }}
                                            </span>
                                            <el-popover ref="editDes" trigger="click" :visible-arrow="false" :offset="0"
                                                placement="left-start" :width="300" v-if="showEditDes" :value="showEditDes">
                                                <edit-value :inputVal="detail.description" v-if="showEditDes"
                                                    :inputValRule="rules.description" @sureEdit="handleEditDes"
                                                    :type="'textarea'" :popTitle="$t('privateNetwork.editDescription')"
                                                    :showEditDes.sync="showEditDes">
                                                </edit-value>
                                            </el-popover>
                                            <el-button type="text" icon="jc-icon-edit" @click="showEditDes = true"
                                                v-popover:editDes>
                                            </el-button>
                                            <div class="jc-colude-mask" v-if="showEditDes"></div>
                                        </el-form-item>
                                    </el-col>
                                    <el-col :span="8">
                                        <el-form-item :label="$t('privateNetwork.area') | withColon">
                                            <span>{{ regions[region] | maybeEmpty }}</span>
                                        </el-form-item>
                                    </el-col>
                                    <el-col :span="8">
                                        <el-form-item :label="$t('privateNetwork.createTime') | withColon">
                                            <span>{{ transformTime(detail.createTime) | maybeEmpty }}</span>
                                        </el-form-item>
                                    </el-col>
                                </el-row>
                            </el-form>
                        </div>
                    </div>
                    <el-divider></el-divider>
                    <div class="jc-section">
                        <div class="jc-section-header">
                            <h3 class="jc-section-title">{{ $t('privateNetwork.configInfo') }}</h3>
                        </div>
                        <div class="jc-section-content">
                            <el-form class="config-info-form">
                                <el-row :gutter="20">
                                    <el-col :span="8">
                                        <el-form-item :label="$t('privateNetwork.segment') + ': '">
                                            <span>{{ detail.cidr | maybeEmpty }}</span>
                                        </el-form-item>
                                    </el-col>
                                    <el-col :span="8">
                                        <el-form-item :label="$t('privateNetwork.ipv6Cidr') + ': '">
                                            <span>{{ detail.ipv6Cidr | maybeEmpty }}</span>
                                        </el-form-item>
                                    </el-col>
                                </el-row>
                            </el-form>
                        </div>
                    </div>
                </el-tab-pane>
                <el-tab-pane name="subnet" :label="$t('privateNetInstance.subnet')">
                    <el-table :data="tableData">
                        <el-table-column prop="vpcName" :label="$t('privateNetwork.tableTitle.name')">
                            <template scope="scope">
                                <a href="javascript:void(0)" @click="jumpToSubnet(scope.row.subnetId, scope.row.region)">
                                    {{ scope.row.name }}
                                </a>
                            </template>
                        </el-table-column>
                        <el-table-column prop="cidr" :label="$t('privateNetwork.tableTitle.cidr')">
                        </el-table-column>
                        <el-table-column prop="ipv6Cidr" :label="$t('privateNetwork.tableTitle.ipv6Cidr')">
                            <template slot-scope="scope">
                                <span>{{ scope.row.ipv6Cidr | maybeEmpty }}</span>
                            </template>
                        </el-table-column>
                        <!-- 						<el-table-column :label="$t('privateNetwork.tableTitle.ratio')">
							<template scope="scope">
								<span>{{ scope.row.availableIpCount + '/' + scope.row.totalIpCount}}</span>
							</template>
						</el-table-column> -->
                    </el-table>
                </el-tab-pane>
                <el-tab-pane name="rib" :label="$t('rib.rib')">
                    <el-table :data="routeDataTable" :empty-text="$t('speechCraft.listEmptyText')">
                        <el-table-column :label="$t('rib.tableTitle.name')">
                            <template scope="scope">
                                <a href="javascript:void(0)" @click="jumpToRibInfo(scope.row)">
                                    {{ scope.row.name }}
                                </a>
                            </template>
                        </el-table-column>
                        <el-table-column :label="$t('rib.tableTitle.type')" prop="type">
                            <template scope="scope">
                                {{ transformType(scope.row.type) }}
                            </template>
                        </el-table-column>
                        <el-table-column :label="$t('rib.tableTitle.createTime')" prop="createTime">
                            <template slot-scope="scope">
                                {{ transformTime(scope.row.createTime) }}
                            </template>
                        </el-table-column>
                    </el-table>
                </el-tab-pane>
                <div v-if="tabName === 'subnet' && total > 0" ref="footer"
                    class="jc-page-footer-detail block jc-container-table-actionBar">
                    <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
                        :current-page="currentPage" :page-sizes="pageSizes" :page-size="pageSize"
                        layout="total, sizes, prev, pager, next, jumper" :total="total">
                    </el-pagination>
                </div>
            </el-tabs>
        </div>
        <del-private-sub :visible.sync="showDel" :region="detail.region" :vpcId="detail.vpcId" :vpcName="detail.name"
            :ipv6Cidr="detail.ipv6Cidr" @refresh="goBack">
        </del-private-sub>
        <ipv6-private :visible.sync="ipv6PrivateShow" :vpcName="detail.name" :vpcId="detail.vpcId" :region="detail.region"
            @refresh="refreshDetail">
        </ipv6-private>
    </div>
</template>

<script>
import { NetworkTypeConstant } from '@/common/Constants';
import dropDownOperation from '@/components/privateNetInstance/dropdownOperation/DropdownOperation';
import editValue from '@/components/privateNetwork/EditValue';
import copyValue from '@/components/privateNetwork/CopyValue';
import delPrivateSub from '@/components/privateNetwork/delPrivateSub/DelPrivateSub';
import ipv6Private from '@/components/privateNetwork/ipv6Private/ipv6Private';
import { getYMD, validateName } from '@/common/dataHelper';

export default {
    name: 'PrivateDetail',
    components: {
        editValue,
        copyValue,
        dropDownOperation,
        delPrivateSub,
        ipv6Private
    },
    data() {
        const valName = (rule, value, callback) => {
            if (!validateName(value)) {
                callback(new Error(this.$t('create.help.name')));
            } else {
                callback();
            }
        };
        const valDes = (rule, value, callback) => {
            if (value.length > 256) {
                callback(new Error(this.$t('detail.speechCraft.descriptionLongRule')));
            } else {
                callback();
            }
        };
        return {
            total: 0,
            pageSizes: [20, 50, 100],
            pageSize: 20,
            currentPage: 1,
            showEditDes: false,
            showDel: false,
            ipv6PrivateShow: false,
            tabName: '',
            vpcName: '',
            // 存储region和regionName
            regions: {},
            region: '',
            detail: {
                vpcId: '',
                name: '',
                description: '',
                region: '',
                cidr: '',
                ipv6Cidr: '',
                createTime: '',
            },
            tableData: [],
            routeDataTable: [], // 路由表列表
            rules: {
                name: [
                    {
                        required: true,
                        message: this.$t('privateNetwork.nameNotNull'),
                    },
                    {
                        validator: valName,
                    }
                ],
                description: [
                    {
                        validator: valDes,
                    }
                ]
            },
            openDel: false,
            operates: [],
            copyHover: false,
            showEditName: false,
            showEditDescription: false,
        };
    },
    async created() {
        this.vpcName = this.$route.query.vpcName;
        this.tabName = this.$route.query.tabName;
        this.detail.peeringCount = this.$route.query.peeringCount;
        this.detail.lbCount = this.$route.query.lbCount;
        this.region = this.$route.query.region;
        const params = {
            vpcId: this.$route.query.id,
            region: this.$route.query.region
        };
        await this.getRegions();
        this.getPrivateNetDetail(params);
        this.getSubnetList(params);
        this.getRibList(params);
    },
    methods: {
        /**
            * 获得region和regionName对照
        */
        async getRegions() {
            const params = {
                networkType: NetworkTypeConstant.VPC
            };
            return Ajax.get('api/cps/getRegions', params).then((res) => {
                if (res.data) {
                    this.regions = res.data.regions.reduce((init, region) => {
                        init[region.region] = region.regionName;
                        return init
                    }, {});
                }
            });
        },
        /**
         * 点击跳转子网详情
         * @param id
         * @param region
         */
        jumpToSubnet(id, region) {
            this.$router.push(
                {
                    path: '/subnet/detail',
                    query: {
                        id,
                        region
                    }
                }
            );
        },
        /**
         * @param type
         * 转化路由表类型
         */
        transformType(type) {
            switch (type) {
                default:
                    return this.$t('rib.defaultRib');
            }
        },
        /**
         * @param row
         * 点击跳转路由表资源信息
         */
        jumpToRibInfo(row) {
            const regionName = this.regions[row.region];
            this.$router.push(
                {
                    path: '/routeTable/detail',
                    query: {
                        region: row.region,
                        routeTableId: row.routeTableId,
                        regionName
                    }
                }
            );
        },
        /**
         * 获取路由表列表
         * 目前只有一条，所以pageSize&pageNumber为默认值
         * @param params
         */
        getRibList(params) {
            Ajax.get('/api/cps/listRouteTables', params)
                .then((res) => {
                    this.routeDataTable = res.data.routeTables;
                });
        },
        handleSizeChange(val) {
            this.pageSize = val;
            const params = {
                pageSize: this.pageSize
            };
            this.getSubnetList(params);
        },
        handleCurrentChange(val) {
            this.currentPage = val;
            const params = {
                pageNumber: this.currentPage
            };
            this.getSubnetList(params);
        },
        goBack() {
            this.$router.push({
                path: '/vpc/list'
            });
        },
        initOperates() {
            const operations = [

            ]
            let name = this.detail.name;
            if (name.indexOf('Default-Game') === -1) {
                operations.push(
                    {
                        operateName: this.$t('privateNetwork.delete'),
                        disabled: this.detail.subnetCount > 0 || this.detail.peeringCount > 0 || this.detail.lbCount > 0,
                        tip: this.detail.subnetCount > 0 ? this.$t('privateNetwork.deleteTip') : this.$t('privateNetwork.deleteForPeering'),
                        value: 'delete'
                    },
                )
            } else {
                operations.push(
                    {
                        operateName: this.$t('privateNetwork.delete'),
                        disabled: true,
                        tip: this.$t('game.tips.deleteVpc'),
                        value: 'delete'
                    },
                )
            }
            let ipv6Cidr = this.detail.ipv6Cidr;
            if (!ipv6Cidr) {
                operations.push({
                    operateName: this.$t('privateNetwork.openIpv6'),
                    value: 'openIpv6'
                })
            }
            this.operates = operations;
        },
        // 点击下拉菜单项
        selectOps(operate) {

            switch (operate) {
                case 'delete':
                    this.showDel = true;
                    //Pop.del_private_net(this, this.detail, 'detail');
                    break;
                case 'openIpv6':
                    this.ipv6PrivateShow = true;
                    break;
                default:
                    break;
            }
        },
        onCopy() {
            this.copyHover = true;
        },
        onError() { },
        // 查询私有网络详情
        getPrivateNetDetail(params) {
            Ajax.get('/api/cps/vpcs', params).then((res) => {
                if (res.errno === 10000 && res.data) {
                    this.detail = Object.assign(this.detail, res.data.vpc);
                    this.initOperates();
                }
            });
        },
        refreshDetail() {
            const params = {
                vpcId: this.detail.vpcId,
                region: this.detail.region
            };
            this.getPrivateNetDetail(params)
        },
        // 编辑详情
        editDetail(params) {
            const defaultParams = {
                region: this.detail.region,
                vpcId: this.detail.vpcId,
            };
            const realParams = Object.assign({}, defaultParams, params);
            Ajax.post('api/cps/vpcs', realParams)
                .then((res) => {
                    if (res.errno === 10000 && res.data) {
                        this.detail = Object.assign(this.detail, res.data);
                    }
                })
                .finally(() => {
                    const detailParams = {
                        region: this.detail.region,
                        vpcId: this.detail.vpcId
                    };
                    this.getPrivateNetDetail(detailParams);
                });
        },
        // 查询子网列表
        getSubnetList(params) {
            const defaultParams = {
                vpcId: this.detail.vpcId,
                region: this.detail.region
            };
            const realParams = Object.assign({}, defaultParams, params);
            Ajax.get('/api/cps/listSubnets', realParams)
                .then((res) => {
                    if (res.errno === 10000 && res.data) {
                        this.tableData = res.data.subnets;
                        this.total = res.data.totalCount;
                    }
                }).finally(() => {
                });
        },
        handleEditName(name) {
            const params = {
                name
            };
            this.editDetail(params);
        },
        handleEditDes(des) {
            const params = {
                description: des
            };
            this.editDetail(params);
        },
        transformTime(time) {
            if (time === '') {
                return '';
            }
            return (getYMD(new Date(time)));
        }
    }
};
</script>

<style lang="scss">
@import "~@/assets/scss/detailCommon.scss";
@import "style";
</style>



// WEBPACK FOOTER //
// src/views/privateNetwork/detail/Detail.vue